var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessageSolidIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#message-solid-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.792 0H3.458A3.337 3.337 0 0 0 .125 3.333v10a3.337 3.337 0 0 0 3.333 3.334h2.436l3.124 2.63c.319.283.718.423 1.114.423.39 0 .776-.136 1.077-.403l3.207-2.65h2.377a3.337 3.337 0 0 0 3.333-3.334v-10A3.337 3.337 0 0 0 16.792 0M5.958 10a1.25 1.25 0 1 1 .001-2.5 1.25 1.25 0 0 1 0 2.5m4.167 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.167 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "message-solid-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.125 0h20v20h-20z"
})))));
export { SvgMessageSolidIcon as ReactComponent };
export default __webpack_public_path__ + "3d2eb6b8cc20e01c6e7e399d2a459279.svg";